import { matchesScheme } from 'monaco-editor/esm/vs/platform/opener/common/opener.js';
import { Schemas } from 'monaco-editor/esm/vs/base/common/network.js';
import { ExtHostTelemetryLogger } from '../vscode/vs/workbench/api/common/extHostTelemetry.js';
import { IExtHostInitDataService } from '../vscode/vs/workbench/api/common/extHostInitDataService.js';
import { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
import { getExtHostServices } from './extHost.js';
import { unsupported } from '../tools.js';
function create(getExtension) {
    return {
        get machineId() { return StandaloneServices.get(IExtHostInitDataService).telemetryInfo.machineId; },
        get sessionId() { return StandaloneServices.get(IExtHostInitDataService).telemetryInfo.sessionId; },
        get language() { return StandaloneServices.get(IExtHostInitDataService).environment.appLanguage; },
        get appName() { return StandaloneServices.get(IExtHostInitDataService).environment.appName; },
        get appRoot() { return StandaloneServices.get(IExtHostInitDataService).environment.appRoot?.fsPath ?? ''; },
        get appHost() { return StandaloneServices.get(IExtHostInitDataService).environment.appHost; },
        get uriScheme() { return StandaloneServices.get(IExtHostInitDataService).environment.appUriScheme; },
        get clipboard() {
            const { extHostClipboard } = getExtHostServices();
            return extHostClipboard.value;
        },
        remoteName: undefined,
        get shell() { return unsupported(); },
        get uiKind() {
            return StandaloneServices.get(IExtHostInitDataService).uiKind;
        },
        async asExternalUri(uri) {
            const { extHostWindow } = getExtHostServices();
            try {
                return await extHostWindow.asExternalUri(uri, { allowTunneling: false });
            }
            catch (err) {
                if (matchesScheme(uri, Schemas.http) || matchesScheme(uri, Schemas.https)) {
                    return uri;
                }
                throw err;
            }
        },
        openExternal: async (uri, options) => {
            const { extHostWindow } = getExtHostServices();
            return extHostWindow.openUri(uri, {
                allowTunneling: false,
                allowContributedOpeners: options?.allowContributedOpeners
            });
        },
        isNewAppInstall: false,
        get isTelemetryEnabled() {
            const { extHostTelemetry } = getExtHostServices();
            return extHostTelemetry.getTelemetryConfiguration();
        },
        get onDidChangeTelemetryEnabled() {
            const { extHostTelemetry } = getExtHostServices();
            return extHostTelemetry.onDidChangeTelemetryEnabled;
        },
        createTelemetryLogger(sender) {
            const { extHostTelemetry } = getExtHostServices();
            ExtHostTelemetryLogger.validateSender(sender);
            return extHostTelemetry.instantiateLogger(getExtension(), sender);
        },
        get logLevel() {
            const { extHostLogService } = getExtHostServices();
            return extHostLogService.getLevel();
        },
        get onDidChangeLogLevel() {
            const { extHostLogService } = getExtHostServices();
            return extHostLogService.onDidChangeLogLevel;
        }
    };
}
export { create as default };
